// removed by extract-text-webpack-plugin
module.exports = {"content":"Survey__content___2P987","main-panel":"Survey__main-panel___2zgHd","table-header":"Survey__table-header___3vU7N","container":"Survey__container___1xj1H"};